module.exports = "pegasus/assets/blocks/column-5-theme6.png";